import http from '@/utils/request';

interface IResData<T> {
  code: number;
  data: T;
  msg: string;
}

const host = '';

export const queryRule = (data: { title: string }) => {
  return http.request<any, IResData<{ content: string }>>({
    url: `${host}/api/v1/omc/public/rule`,
    method: 'get',
    params: data,
  });
};

export const saveRule = (data: { title: string; content: string }) => {
  return http.request<any, void>({
    data,
    method: 'post',
    url: `${host}/api/v1/omc/public/rule`,
  });
};
